var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRemove = function SvgRemove(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M15.858 3h-3.572l-.28-.584a.71.71 0 0 0-.64-.416H7.965a.7.7 0 0 0-.637.416L7.048 3H3.476A.49.49 0 0 0 3 3.5v1a.49.49 0 0 0 .476.5h12.381a.49.49 0 0 0 .477-.5v-1a.49.49 0 0 0-.476-.5M4.584 16.6A1.467 1.467 0 0 0 6.01 18h7.315a1.467 1.467 0 0 0 1.425-1.407L15.383 6H3.952z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRemove);
export default ForwardRef;